
import { get_now_ms } from "../../lib/time";

/**
 * Samples a event until a condition is satisfied.
 */
class PollSample {

  /**
   * @param delay_ms {Number}
   * @param sample_promise_func {() => Promise<boolean>} Returns a promise
   *   that tests the condition and resolves true if its finished.
   * @param on_timeout_error: {function} Called when
   * @param timeout_ms: {Number} If the sample promise doesn't finish by this
   *    time, then it fails. Defaults to 1 minute.
   * @param on_done: {() => {}} Callback when completed.
   */
  constructor(
    delay_ms, sample_promise_func, on_timeout_error,
    timeout_ms = 30 * 1000, on_done = () => {}) {
    this.delay_ms = delay_ms;
    this.sample_promise_func = sample_promise_func;
    this.on_timeout_error = on_timeout_error;
    this.timeout_ms = timeout_ms;
    this.on_done = on_done;
    this.verb = false;
  }

  startCallback = (reset = true) => {
    if (reset) {
      this.start_ms = get_now_ms();
    }
    if (this.verb) {
      console.log("PollSample.startCallback")
    }
    this.time_out = setTimeout(() => {
      if (this.verb) {
        console.log("PollSample.onTimeout")
      }
      this.sample_promise_func()
        .then(is_done => {
          if (this.verb) {
            console.log("PollSample.onTimeout", is_done);
          }
          if (is_done) {
            delete this.time_out;
            this.on_done();
          } else {
            const now_ms = get_now_ms();

            if (now_ms - this.start_ms >= this.timeout_ms) {
              // Fail.
              if (this.on_timeout_error) {
                this.on_timeout_error();
              }
            } else {
              this.startCallback(false);
            }
          }
        })
    }, this.delay_ms);
  }

  maybeClearTimeout = () => {
    if (this.time_out) {
      delete this.time_out;
    }
  }
}

export { PollSample };
